export default __webpack_public_path__ + "static/media/pepe_small.529dfaa5.png";